
import { MLBTheme } from '../../../style/theme.types';
import styled, { AnyStyledComponent } from 'styled-components';
import COLORS from '../../../style/universal.color';
import BREAKPOINTS from '../../../style/breakpoints';

interface PropsTypes {
  theme: MLBTheme;
}
export const Wrapper: AnyStyledComponent = styled.div`
    display: flex;
    align-items: center;
    padding: 32px 14px 22px 14px;
    @media only screen and (min-width: ${BREAKPOINTS.md}) {
      padding: 14px;
    }
`;

export const Title: AnyStyledComponent = styled.h1`
  position: absolute;
  right: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0;
  font-family: ${(props: PropsTypes) => props.theme?.fonts?.family?.primary};
  font-size: 18px;
  color: ${(props: PropsTypes) => props.theme?.dark ? COLORS.mlbWhite : COLORS.mlbBlack};
`;

interface styledButtonsWrapperProps {
  closeButtonRight: boolean;
}
export const ButtonsWrapper: AnyStyledComponent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  z-index: 1;
  flex-direction: ${({closeButtonRight}: styledButtonsWrapperProps) => closeButtonRight ? 'row-reverse' : 'row'};
`;

export const CloseButtonWrapper: AnyStyledComponent = styled.div`
  margin-left: -10px;
`;
